import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './Components/Navbar';
import RSNGHome from './Pages/RSNGHome';
import RSNGServices from './Pages/RSNGServices';
import RSNGAbout from './Pages/RSNGAbout';
import RSNGCareers from './Pages/RSNGCareers';
import RSNGCaseStudies from './Pages/RSNGCaseStudies';
import RSNGContact from './Pages/RSNGContact';
import EMedicarematch from './Pages/EMedicarematch';
import ZenoHire from './Pages/ZenoHire';
import ZenoPolicy from './Pages/ZenoPolicy';
import AICaregiving from './Pages/AICaregiving';
import Azentris from './Pages/Azentris';
import Fotter from './Components/Fotter';


function App() {
  return (
    <Router>
      <Navbar/>
      <Routes>
        <Route path="/" element={<RSNGHome />} />
        <Route path="/services" element={<RSNGServices />} />
        <Route path="/careers" element={<RSNGCareers />} />
        <Route path="/case-studies" element={<RSNGCaseStudies />} />
        <Route path="/products/emedicarematch" element={<EMedicarematch />} />
        <Route path="/products/zenohire" element={<ZenoHire />} />
        <Route path="/products/zenopolicy" element={<ZenoPolicy />} />
        <Route path="/products/aicaregiving" element={<AICaregiving />} />
        <Route path="/products/azentris" element={<Azentris />} />
        <Route path="/about" element={<RSNGAbout />} />
        <Route path="/contact" element={<RSNGContact />} />
      </Routes>
      <Fotter/>
    </Router>
  );
}

export default App;
